import React from 'react'
import { Highlight } from '@mobi/component-library/Typography/Highlight'
import type { HighlightToken, MetaDataHighlight } from '@core/Areas/Search/types'

interface Props {
  displayText: string
  highlights: MetaDataHighlight
  highlightKey: string
}

export const HighlightDisplay: React.FC<Props> = ({ displayText, highlights, highlightKey }) => {
  if (!highlights[highlightKey]) return displayText

  return highlights[highlightKey].map((token: HighlightToken, index: number) => {
    const key = `${token.value}_${index}`
    return token.isMatch ? (
      <Highlight key={key}>{token.value}</Highlight>
    ) : (
      <span key={key}>{token.value}</span>
    )
  })
}
